import { connect } from 'react-redux';

import { selectSelectedScheduleInstanceId } from '../../../Schedules.selectors';
import { setSelectedInstanceId as setSelectedInstanceIdAction } from '../../../Schedules.saga';
import ScheduleRow from './ScheduleRow';

const mapStateToProps = (state, ownProps) => {
  return {
    selectedScheduleInstanceId: selectSelectedScheduleInstanceId(state),
    ...ownProps,
  };
};

const mapDispatchToProps = {
  setSelectedInstanceId: setSelectedInstanceIdAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { selectedScheduleInstanceId, instanceId } = stateProps;
  const { setSelectedInstanceId, ...restDispatchProps } = dispatchProps;

  return {
    setSelectedInstanceId: setSelectedInstanceId.bind(null, { instanceId, focus: 'preview' }),
    isSelected: selectedScheduleInstanceId === instanceId,
    ...stateProps,
    ...restDispatchProps,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ScheduleRow);
